import { Link, useSearchParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";

import { Button } from "@/components/Button";
import { ApiError, bookingsApi } from "@/lib/api";
import type { CancelResponse } from "@/types/api";

export function CancelPage() {
  const [params] = useSearchParams();
  const token = params.get("token");

  const mutation = useMutation<CancelResponse, ApiError, string>({
    mutationFn: bookingsApi.cancel,
  });

  return (
    <div className="mx-auto max-w-2xl px-6 py-16 text-center">
      <h1 className="mb-3 font-display text-h1 uppercase text-primary">Buchung stornieren</h1>
      {!token && (
        <p className="text-body-sm text-ink-soft">
          Storno-Token fehlt. Bitte den Link aus der Bestätigungs-Email öffnen.
        </p>
      )}

      {token && !mutation.data && !mutation.error && (
        <>
          <p className="mb-6 text-lead text-ink-soft">
            Möchtest du diese Buchung wirklich stornieren? Charlie wird automatisch informiert.
          </p>
          <Button
            variant="danger"
            size="lg"
            loading={mutation.isPending}
            onClick={() => mutation.mutate(token)}
          >
            Buchung jetzt stornieren
          </Button>
        </>
      )}

      {mutation.isSuccess && (
        <>
          <p className="mb-6 text-lead text-ink-soft">
            {mutation.data.message ?? "Buchung storniert. Danke für die Info."}
          </p>
          <Link to="/" className="text-primary underline">
            Zur Startseite
          </Link>
        </>
      )}

      {mutation.isError && (
        <p className="mt-6 text-body-sm text-danger">{mutation.error.message}</p>
      )}
    </div>
  );
}
